import * as Sentry from '@sentry/react';

const dsn = window.ReactAppEnv?.sentry?.dsn;
const isLocalhost = window.location.hostname === 'localhost';

// Baked at build time by build:client. Must match the release name the Sentry
// vite plugin uploads sourcemaps under (see vite.config.js). Only set when both
// are present, so a missing var degrades to "no release tag" (today's
// behaviour) rather than an "undefined+undefined" release.
const version = import.meta.env.VITE_CLIENT_VERSION;
const build = import.meta.env.VITE_CLIENT_BUILD;
const release = version && build ? `${version}+${build}` : undefined;

if (dsn && !isLocalhost) {
  Sentry.init({
    dsn,
    environment: window.ReactAppEnv?.sentry?.environment,
    release,
    sendDefaultPii: false,
  });
}
